import React from 'react';
import { Icon } from '../../../../../../../components';

export const Input = ({
  value,
  setValue,
  placeholder,
  showCount,
  maxLength,
  error,
  errorText,
  name
}: any) => (
  <div data-testid="cmp-input-phone">
    <input
      data-testid="cmp-input-phone-number"
      type="text"
      className={`${value ? 'inputFilled' : ''}  ${error ? 'inputError' : ''} `}
      value={value}
      onChange={(e) => {
        setValue({
          name,
          value: e.target.value
            .replace(/[^0-9.]/g, '')
            .replace(/(\..*)\./g, '$1')
            .replace(/\./g, '')
        });
      }}
      placeholder={placeholder}
      maxLength={15}
    />

    {showCount && (
      <div
        className="inputFooter"
        style={{
          marginTop: 4,
          justifyContent: error ? 'space-between' : 'flex-end',
          display: 'flex',
          fontSize: 12
        }}
      >
        {error && (
          <div className="errorText" data-testid="cmp-input-phone-error">
            <Icon name="alert-triangle" size={12} />
            {errorText}
          </div>
        )}
        {value.length} / {maxLength}
      </div>
    )}
  </div>
);
